
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ComingSoonPage from '../pages/coming-soon/page';
import ProfilePage from '../pages/profile/page';
import DiscographyPage from '../pages/discography/page';
import BlogPage from '../pages/blog/page';
import LivePage from '../pages/live/page';
import NewsPage from '../pages/news/page';
import NotFound from '../pages/NotFound';
import ContactPage from '../pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <ComingSoonPage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/discography',
    element: <DiscographyPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/live',
    element: <LivePage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
